import * as React from "react"
import { Admin, Resource, defaultTheme, Login, CustomRoutes, useResourceContext } from 'react-admin'
import UsersList from './components/customer/UsersList'
import CreateUser from './components/customer/CreateUser'
import EditUser from './components/customer/EditUser'
import authProvider from './utils/authProvider'
import CustomLayout from './components/common/CustomLayout'
import Dashboard from './components/common/Dashboard'
import NowOnlineList from './components/customer/NowOnlineList'
import CustomerGroupsList from './components/customer/CustomerGroupsList'
import AddCustomerGroup from './components/customer/AddCustomerGroup'
import resourceDataProvider from './utils/dataProvider'
import { Route } from "react-router-dom"
import LoginPage from './components/common/LoginPage'
import OrderList from './components/orders/OrderList'
import ShipmentStatusList from './components/orders/ShipmentStatusList'
import ShipmentList from './components/shipment/ShipmentList'
import ShipmentDetails from './components/shipment/ShipmentDetails';
import InvoiceList from './components/invoice/InvoiceList'
import OrderDetails from './components/orders/OrderDetails'
import AddInvoice from './components/invoice/AddInvoice'
import CouponList from "./components/coupon/CouponList"
import AddCoupon from "./components/coupon/AddCoupon"
import EditCoupon from "./components/coupon/EditCoupon"
import InvoiceDetails from './components/invoice/InvoiceDetails'
import ReturnsList from './components/returns/ReturnsList'
import CreateReturn from './components/returns/CreateReturn'
import EditReturn from './components/returns/EditReturn'
import AddCreditMemo from "./components/creditMemo/AddCreditMemo"
import CreditMemoList from "./components/creditMemo/CreditMemoList"
import CreditMemoDetails from "./components/creditMemo/CreditMemoDetails"
import ChangeShipping from "./components/shipment/ChangeShipping"
import Configuration from "./components/store/configuration"
import OrderExports from './components/reports/orderExports'
import OrderCreate from "./components/orders/OrderCreate"
import Tamara from "./components/payment/TamaraConfiguration"
import TabbyConfiguration from "./components/payment/TabbyConfiguration"
import ProductExports from "./components/reports/productExports"
import ProductMasterSheet from "./components/reports/productMasterSheet"
import BundleReportSheet from "./components/reports/bundleReportSheet"
import CorporateGifting from "./components/reports/corporateGifting"
import AdminLogin from "./components/common/AdminLogin"
import PaymentConfiguration from "./components/payment/PaymentConfiguration"
import AddProduct from "./components/products/AddProduct"
import ProductList from "./components/products/ProductListing"
import EditProduct from "./components/products/EditProduct"
import ProductReview from "./components/review/ProductReview";
import DetailedReview from "./components/review/DetailedReview";
import WinterOrderList from "./components/orders/WinterOrderList";
import WinterOrderDetail from "./components/orders/WinterOrderDetail";
import GiftList from "./components/gifts/GiftList"
import AddGift from "./components/gifts/AddGift"
import EditGift from "./components/gifts/EditGift"
import CacheConfiguration from "./components/cache/cacheConfiguration"
import StorePickup from './components/orders/StorePickuplist'
import NddList from './components/orders/Nddlist'



const theme = {
  ...defaultTheme
}

function App() {
  React.useEffect(()=> {
    const appName = process.env.REACT_APP_APP_NAME
    document.title = appName
  },[])
  const renderLayout = (props) => {
    return (
      <>
        <AdminLogin />
        <CustomLayout {...props} />
      </>
    );
  };
  
  return (
  <Admin 
    dataProvider={resourceDataProvider}
    authProvider={authProvider}
    requireAuth
    layout={renderLayout}
    title='Aragorn'
    dashboard={Dashboard}
    theme={theme}
    loginPage={<LoginPage/>}
   
  >
    
    
 
    <Resource 
      name="users" 
      options={{ "label" : "Customers", "storeId" : 1000 }} 
      list={<UsersList totalUsers='122740'/>} 
      //create={CreateUser} 
      //edit={<EditUser edit={true}/>}
    />
      <CustomRoutes>
        <Route path='/users/add' element={<><CreateUser/><AdminLogin/></>}/>
        <Route path='/users/:id' element={<><EditUser/><AdminLogin/></>}/>
        <Route path='/orders' element={<><OrderList/><AdminLogin/></>}/>
        <Route path='/orders/:id' element={<><OrderDetails/><AdminLogin/></>}/>
        <Route path='/now-online' element={<><NowOnlineList/><AdminLogin/></>}/>
         <Route path='/pending-orders/ndd' element={<><NddList/><AdminLogin/></>}/>
        <Route path='/pending-orders/store-pickup' element={<><StorePickup/><AdminLogin/></>}/>
        <Route path='/customer-groups' element={<><CustomerGroupsList/><AdminLogin/></>}/>
        <Route path='/add-customer-group' element={<><AddCustomerGroup/><AdminLogin/></>}/>
        <Route path='/shipment-status' element={<><ShipmentStatusList/><AdminLogin/></>}/>
        <Route path='/shipments' element={<><ShipmentList/><AdminLogin/></>}/>
        <Route path='/invoices' element={<><InvoiceList/><AdminLogin/></>}/>
        <Route path='/invoice/add/:id' element={<><AddInvoice/><AdminLogin/></>}/>
        <Route path='/cart-price-rule' element={<><CouponList/><AdminLogin/></>}/>
        <Route path='/add-coupon' element={<><AddCoupon/><AdminLogin/></>}/>
        <Route path='/edit-coupon/:id' element={<><EditCoupon/><AdminLogin/></>}/>
        <Route path='/invoice/:id' element={<><InvoiceDetails/><AdminLogin/></>}/>
        <Route path='/shipment/add/:id' element={<><AddInvoice/><AdminLogin/></>}/>
        <Route path='/shipment/:id' element={<><ShipmentDetails/><AdminLogin/></>}/>
        <Route path='/returns' element={<><ReturnsList/><AdminLogin/></>}/>
        <Route path='/create-return/:id' element={<><CreateReturn/><AdminLogin/></>}/>
        <Route path='/edit-return/:id' element={<><EditReturn/><AdminLogin/></>}/>
        <Route path='/creditMemo/:id' element={<><CreditMemoDetails/><AdminLogin/></>}/>
        <Route path='/creditMemo/add/:id' element={<><AddCreditMemo/><AdminLogin/></>}/>
        <Route path='/creditMemos' element={<><CreditMemoList/><AdminLogin/></>}/>
        <Route path='/shipment/change-shipping' element={<><ChangeShipping/><AdminLogin/></>}/>
        <Route path='/configuration' element={<><Configuration/><AdminLogin/></>}/>
        <Route path='/orderExports' element={<><OrderExports/><AdminLogin/></>}/> 
        <Route path='/productExports' element={<><ProductExports/><AdminLogin/></>}/>
        <Route path='/productMasterSheet' element={<><ProductMasterSheet/><AdminLogin/></>}/> 
        <Route path='/bundleReportSheet' element={<><BundleReportSheet/><AdminLogin/></>}/> 
        <Route path='/corporateGifting' element={<><CorporateGifting/><AdminLogin/></>}/>
        <Route path="/orders/order-create" element={<><OrderCreate/><AdminLogin/></>}/>
        <Route path="/payment/configuration" element={<><PaymentConfiguration/><AdminLogin/></>}/>
        <Route path="/cache" element={<><CacheConfiguration/><AdminLogin/></>}/>
        <Route path='/products' element={<><ProductList/><AdminLogin/></>}/>
        <Route path="/products/addproduct/" element={<><AddProduct/><AdminLogin/></>}/>
        <Route path="/products/editproduct/:id" element={<><EditProduct/><AdminLogin/></>}/>
        <Route path="/reviews" element={<><ProductReview/><AdminLogin/></>}/>
        <Route path='/product/detailedreview/:id' element={<><DetailedReview /><AdminLogin/></>}/>

        <Route path='/winterorders' element={<><WinterOrderList/><AdminLogin/></>}/>
        <Route path="/orders/winterorders/:orderId" element={<><WinterOrderDetail/><AdminLogin/></>}/>
        <Route path='/gift-cart-rule' element={<><GiftList/><AdminLogin/></>}/>
        <Route path='/add-gift' element={<><AddGift/><AdminLogin/></>}/>
        <Route path='/edit-gift/:id' element={<><EditGift/><AdminLogin/></>}/>


        <Route/>
      </CustomRoutes>
  </Admin>
  )
};

export default App;
